import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  private requests: HttpRequest<any>[] = [];
  private exclusions: RegExp[];

  constructor(private loaderService: LoaderService) {
    this.exclusions = [
      new RegExp('/api/auth/v1'),
      new RegExp('/api/dashboard'),
      new RegExp('/api/holiday/v1'),
      new RegExp('/api/holiday/v1/.*'),
      new RegExp('/api/company/v1'),
      new RegExp('/api/employee/v1/address'),
      new RegExp('/api/employee/v1/address'),
      new RegExp('/api/employee/v1/user'),
      new RegExp('https://api.postalpincode.in/pincode'),
      new RegExp('/api/workday/v1'),
      new RegExp('/api/workday/v1/.*'),
      new RegExp('/api/context/v1/weekday'),
      new RegExp('/api/title/v1'),
      new RegExp('/api/title/v1/.*'),
      new RegExp('/api/context/v1/level'),
      new RegExp('/api/context/v1/band'),
      new RegExp('/api/menu/module'),
      new RegExp('/api/menu/menu'),
      new RegExp('/api/role/v1'),
      new RegExp('/api/leave/v1'),
      new RegExp('/api/leave/v1/.*'),
      new RegExp('/api/context/v1'),
      new RegExp(`/api/regular/v1`),
      new RegExp(`/api/regular/v1/*`),
      new RegExp('/api/bank/v1'),
      new RegExp('/api/bank/v1/.*'),
      new RegExp('/api/medium/v1'),
      new RegExp('/api/medium/v1/.*'),
      new RegExp('/api/family/v1'),
      new RegExp('/api/family/v1/.*'),
      new RegExp('/api/timeline/v1'),
      new RegExp('/api/timeline/v1/.*'),
      new RegExp('/api/payroll'),
      new RegExp('/api/context/v1'),
      new RegExp('/api/absence/v1'),
      new RegExp('/api/employee/v1'),
      new RegExp('/api/profile/v1'),
      new RegExp('/api/finance/v1'),
      new RegExp('/api/appraisal/v1'),
      new RegExp('/api/appraisal/v1'),
      new RegExp('/api/setup/epochs'),
      new RegExp('/api/setup/quarters'),
      new RegExp('/api/finance/v1/journals'),
      new RegExp('/api/finance/v1/finance-report'),
      new RegExp('/api/config/countries'),
      new RegExp('/api/config/currencies'),
      new RegExp('/api/config/timezone'),
      new RegExp('/api/home/notification'),
      new RegExp('/api/home/dashboard'),
      new RegExp('/api/v1/image'),
      new RegExp('/api/project-pilot/v1'),
      new RegExp('/api/image/v1/type'),
      new RegExp('/api/setup/employee-insurances'),
      new RegExp('/api/setup/metrics'),
      new RegExp('/api/setup/performances'),
      new RegExp('/api/setup/socials'),
      new RegExp('/api/setup/insurances'),
      new RegExp('/api/config/currency'),
      new RegExp('/api/image/v1'),
      new RegExp('/api/course/v1'),
      new RegExp('/api/course/v1/course-slide'),
      new RegExp('/api/course/v1/question-category'),
      new RegExp('/api/v1/course-test'),
      new RegExp('/api/course/v1/course-test-questionnaire'),
      new RegExp('/api/course/v1/course-slide/upload'),
      new RegExp('/api/course/v1/course-question`'),
      new RegExp('/api/project-pilot/teams`'),
      new RegExp('/api/project-pilot/team-roles`'),
      new RegExp('/api/project-pilot/projects`'),
      new RegExp('/api/project-pilot/v1/milestones`'),
      new RegExp('/api/separation/separation-list`'),
      new RegExp('/api/separation/separation-approval-list`'),
      new RegExp('/api/separation/termination-list`'),
      new RegExp('/api/separation'),
      new RegExp('/api/dossier/v1/kyc'),
      new RegExp('/api/dossier/v1/kycs'),
      new RegExp('/api/personnel/qualification'),
      new RegExp('/api/personnel/qualifications'),
      new RegExp('/api/personnel/experience'),
      new RegExp('/api/personnel/experiences'),
      new RegExp('/api/personnel/experiences'),
      new RegExp('/api/finance/v1/voucher'),
      new RegExp('/api/finance/v1/vouchers'),
      new RegExp('/api/finance/v1/voucher-entry'),
      new RegExp('/api/finance/v1/voucher-entries'),
      new RegExp('/api/finance/v1/profit-loss-report'),
      new RegExp('/api/home/announcements'),
      new RegExp('/api/home/announcement')






    ];
  }
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.excludes(request.url)) {
      this.requests.push(request);
      this.loaderService.isLoading.next(true);
      return Observable.create(observer => {
        const subscription = next.handle(request)
          .subscribe(
            event => {
              if (event instanceof HttpResponse) {
                this.stash(request);
                observer.next(event);
              }
            },
            err => {
              this.stash(request);
              observer.error(err);
            },
            () => {
              this.stash(request);
              observer.complete();
            });
        return () => {
          this.stash(request);
          subscription.unsubscribe();
        };
      });
    }
    return next.handle(request);
  }

  excludes(url: string,): boolean {
    // return this.excludedUrls.some(rx => rx.method.includes(method) && rx.url.test(url));
    return this.exclusions.some(rx => rx.test(url));
  }

  stash(request: HttpRequest<any>) {
    const i = this.requests.indexOf(request);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }
}
